import { SpacingComponent } from '@varo/graphql-schema-types';
import { VXLSpacing } from 'shared/components/sdui/VXLSpacing';
import { VXLNode } from 'shared/renderer/types';

export const SPACER_PREFIX = 'spacer';

const vxlSpacing = (component: SpacingComponent, index: number): VXLNode => {
  return {
    id: `${SPACER_PREFIX}-${index}-${component.id}`,
    render: () => VXLSpacing(component),
  };
};

export default vxlSpacing;
